module.exports = __webpack_public_path__ + "img/Support-skill-514.3946ba8f.png";